import Vue from "vue";
import VModal from 'vue-js-modal'
import {Decimal} from 'decimal.js';

import CashoutForm from "./components/CashoutForm.vue"
import {CashoutData, loadSkus, loadTags, makeSkuMap} from "./models"

const environmentsToLog = ['Flow-Test', 'Flow-Sandbox', 'Flow-Production'];
const environment = (window as any).environment;

// Modal plugin
Vue.use(VModal, {dialog: true});

// Get required data
let cashoutPreloadData = (window as any).cashoutPreloadData;

function initCashout() {
    if (!cashoutPreloadData) return;

    let skus = loadSkus(cashoutPreloadData.skus);
    let skuMap = makeSkuMap(skus);
    loadTags(cashoutPreloadData.countryTags, cashoutPreloadData.categoryTags);
    let cashoutData = new CashoutData(cashoutPreloadData.userData, cashoutPreloadData.walletData);

    cashoutData.minCryptoAmount = new Decimal(cashoutPreloadData.minCryptoAmount);
    cashoutData.feeSavingMultiplier = new Decimal(cashoutPreloadData.feeSavingMultiplier);

    let cashoutForm = new Vue({
        el: '#cashout-form',
        data: {
            skus: skus,
            cashoutData: cashoutData,
            step: 1
        },
        components: {
            CashoutForm,
        },
        template: `<CashoutForm :skus="skus" :cashoutData="cashoutData" />`
    });

    // Easy access for debug
    (window as any).cashoutData = cashoutData;
    (window as any).skus = skus;
    (window as any).skuMap = skuMap;
    (window as any).cashoutForm = cashoutForm;
}

initCashout();
